import * as config from '../../config_module';
import { PARAMS } from '../../const';

const API_PREFIX = '/api/v2';
const API_PREFIX_V3 = '/api/v3';

export const API_USERS = `${config.BACKEND_URL}${API_PREFIX}/users`;
export const API_USERS_V3 = `${config.BACKEND_URL}${API_PREFIX_V3}/users`;
export const API_USERS_TASKS = `${API_USERS}/${PARAMS.USER}/tasks`;
export const API_USERS_TASKS_V3 = `${API_USERS_V3}/${PARAMS.USER}/tasks`;

export const API_CLASSROOMS = `${config.BACKEND_URL}${API_PREFIX}/classrooms`;
export const API_CLASSROOMS_V3 = `${config.BACKEND_URL}${API_PREFIX_V3}/classrooms`;
export const API_CLASSROOMS_ASSIGNMENTS = `${API_CLASSROOMS}/${PARAMS.CLASSROOM}/tasks`;
export const API_CLASSROOMS_TASKS_CONTENT = `${API_CLASSROOMS}/${PARAMS.CLASSROOM}/tasks/content`;
export const API_CLASSROOMS_TASKS_INDIVIDUAL = `${API_CLASSROOMS}/${PARAMS.CLASSROOM}/tasks/individual`;
export const API_CLASSROOMS_TASKS_GROUP = `${API_CLASSROOMS}/${PARAMS.CLASSROOM}/tasks/group`;
export const API_CLASSROOMS_ASSIGNMENTS_V3 = `${API_CLASSROOMS_V3}/${PARAMS.CLASSROOM}/tasks`;
export const API_CLASSROOMS_ASSIGNMENTS_PAGINATION = `${API_CLASSROOMS_ASSIGNMENTS}?page=${PARAMS.PAGE}&perPage=${PARAMS.ITEMS}`;

export const API_USERS_TASKS_RESPONSES = `${API_USERS_TASKS_V3}/${PARAMS.TASK}/responses`;
export const API_USERS_TASKS_EVALUATIONS = `${API_CLASSROOMS_ASSIGNMENTS_V3}/${PARAMS.TASK}/users/${PARAMS.USER}/evaluations`;

export const API_CLASSROOMS_ASSIGNMENTS_TASKS = `${API_CLASSROOMS_ASSIGNMENTS}/${PARAMS.TASK}`;
export const API_CLASSROOMS_ASSIGNMENTS_TASKS_USERS = `${API_CLASSROOMS_ASSIGNMENTS_TASKS}/users`;
export const API_SECTIONS = `${config.BACKEND_URL}${API_PREFIX}/sections`;
export const API_SECTIONS_ASSIGNMENTS = `${API_SECTIONS}/${PARAMS.SECTION}/tasks`;
